import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import "./mui-table.scss";
import CustomTooltip from "./custom-tooltip";

interface RenderCellContentProps {
  text: any; 
}

const RenderCellContent: React.FC<RenderCellContentProps> = ({ text }) => {
  const cellRef = useRef<HTMLDivElement | null>(null);
  const [isTextTruncated, setIsTextTruncated] = useState<boolean>(false);

  useEffect(() => {
    const cell = cellRef.current;
    if (!cell) return;

    const checkTextTruncation = () => {
      const clone = document.createElement("div");
      clone.style.visibility = "hidden";
      clone.style.position = "absolute";
      clone.style.whiteSpace = "nowrap";
      clone.style.font = window.getComputedStyle(cell).font;
      clone.textContent = text;
      document.body.appendChild(clone);

      const contentWidth = clone.offsetWidth;
      const isTruncated = contentWidth > cell.clientWidth;

      setIsTextTruncated(isTruncated);
      document.body.removeChild(clone);
    };

    checkTextTruncation();
    const observer = new ResizeObserver(checkTextTruncation);
    observer.observe(cell);

    return () => observer.disconnect();
  }, [text]);

  const isReactElement = React.isValidElement(text);

  return (
    <div ref={cellRef} className="render-cell-content">
      {isReactElement ? (
        <span>{text}</span>
      ) : (
        isTextTruncated ? (
          <CustomTooltip
          title={typeof text === "string" ? text : ""}
            placement="bottom"
            arrow
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [100, 0],
                  },
                },
              ],
            }}
          >
            <span className="truncated-text">{text}</span>
          </CustomTooltip>
        ) : (
          <span className="truncated-text" title={text}>
            {text}
          </span>
        )
      )}
    </div>
  );
};

export default RenderCellContent;
